var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayasyouusemodel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pay_as_you_use_model_",
    "data-name": "Pay as you use model ",
    transform: "translate(-17597 -8511)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_589",
    "data-name": "Ellipse 589",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(17597 8511)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "credit-card-payment",
    transform: "translate(17636.996 8550.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19693",
    "data-name": "Path 19693",
    d: "M75,257H94.278v8.262H75Z",
    transform: "translate(-54.345 -186.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19694",
    "data-name": "Path 19694",
    d: "M106.03,182H12.393A12.407,12.407,0,0,0,0,194.393v66.1a12.407,12.407,0,0,0,12.393,12.393H106.03a12.407,12.407,0,0,0,12.393-12.393v-66.1A12.407,12.407,0,0,0,106.03,182ZM12.393,198.524a4.131,4.131,0,0,1,4.131-4.131h27.54a4.131,4.131,0,0,1,4.131,4.131v16.524a4.131,4.131,0,0,1-4.131,4.131H16.524a4.131,4.131,0,0,1-4.131-4.131ZM16.524,235.7h8.262a4.131,4.131,0,1,1,0,8.262H16.524a4.131,4.131,0,1,1,0-8.262Zm27.54,24.786H16.524a4.131,4.131,0,0,1,0-8.262h27.54a4.131,4.131,0,0,1,0,8.262Zm5.508-16.524H41.311a4.131,4.131,0,1,1,0-8.262h8.262a4.131,4.131,0,1,1,0,8.262Zm24.786,0H66.1a4.131,4.131,0,1,1,0-8.262h8.262a4.131,4.131,0,1,1,0,8.262ZM101.9,219.18H88.129a4.131,4.131,0,0,1,0-8.262H101.9a4.131,4.131,0,0,1,0,8.262Zm0-16.524H88.129a4.131,4.131,0,1,1,0-8.262H101.9a4.131,4.131,0,1,1,0,8.262Z",
    transform: "translate(0 -131.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19695",
    "data-name": "Path 19695",
    d: "M452.6,184.692l-8.2-30.592-13.794,3.7a20.629,20.629,0,0,1,8.094,16.381v27.069l5.134-1.376A12.407,12.407,0,0,0,452.6,184.692Z",
    transform: "translate(-312.019 -111.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19696",
    "data-name": "Path 19696",
    d: "M288.636,111.528l27.625-7.4-2.138-7.981-57.409,15.383Z",
    transform: "translate(-186.014 -69.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19697",
    "data-name": "Path 19697",
    d: "M32.425,41.862H61.573L148.765,18.5l-2.495-9.311A12.407,12.407,0,0,0,131.092.424L40.646,24.659a12.407,12.407,0,0,0-8.763,15.179Z",
    transform: "translate(-22.795 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayasyouusemodel);
export default __webpack_public_path__ + "static/media/Pay as you use model.427d4082965f7d42767a1a663b170db7.svg";
export { ForwardRef as ReactComponent };